module.exports = __webpack_public_path__ + "img/23400.95e65536.jpg";